module.exports = __webpack_public_path__ + "img/Mary Pan.c1ff44e3.jpg";